module.exports = require('./lib/plantuml-encoder')
